import { render, staticRenderFns } from "./gameItem.vue?vue&type=template&id=cd158142&"
import script from "./gameItem.vue?vue&type=script&lang=js&"
export * from "./gameItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports